import React, { ComponentProps } from 'react';
import { AnnouncementList } from './partials/AnnouncementList/AnnouncementList';
import { asBlock } from '../../_lib/BlockFetcher';
import { BlockType } from '../../types/api/ElementType';
import { DefaultView, OptionalEditView } from '../../types/BlockWithViews';
import { PaginationItemWithPageLink } from '../../_lib/components/Pagination';
import { AnnouncementProps } from './Announcement.types';

type AnnouncementsOutBoxViewProps = { announcements: AnnouncementProps[]; pageItems: PaginationItemWithPageLink[] };

type AnnouncementsOutboxProps = {
  views: DefaultView<AnnouncementsOutBoxViewProps> & OptionalEditView<AnnouncementsOutBoxViewProps>;
};

function AnnouncementsOutbox({ views }: AnnouncementsOutboxProps) {
  const { announcements, pageItems } = views.edit ? views.edit.embedded : views.default.embedded;

  return <AnnouncementList announcements={announcements} pageItems={pageItems} />;
}

export const AnnouncementsOutboxBlock = asBlock(AnnouncementsOutbox, BlockType.allannouncementsoutbox);
export type AnnouncementsOutboxBlock = ComponentProps<typeof AnnouncementsOutboxBlock>;
